<template>
  <div>
    <div v-if="$slots.precontent" class="ca-tabla-prev">
      <slot name="precontent"></slot>
    </div>
    <v-data-table
      :height="getHeight()"
      @toggle-select-all="$emit('select-all', $event)"
      :group-by="secciones_agrupar"
      :group-desc="invertir_agrupar"
      :custom-group="custom_group"
      :id="id" v-scroll:[idCompleto]="onScroll"
      dense :headers="headers" :items="itemsAMostrar"
      :loading="loading"
      :loading-text="this.loading_text || 'Buscando...'"
      :options.sync="opciones"
      :hide-default-header="ocultar_header"
      :disable-pagination="!paginado"
      hide-default-footer
      :headers-length="headers_length"
      :show-select="columna_seleccionar_todo"
      v-model="seleccionados_copy"
      class="ca-tabla"
      :no-data-text="no_data_text"
      :fixed-header="header_fijo"
      :style="{ 'max-height': heightTabla, 'min-height': heightTabla }"
      :class="{
        'ca-tabla--paginada': numeroDePaginas > 1,
        'ca-tabla--scrollable': scrollable,
        'ca-tabla--virtual-scroll': virtual_scrolling,
        'ca-tabla--dark': dark,
        'ca-tabla-header--small': header_small,
        'filas-clickables': filas_clickeables,
        'filas-hover': filas_hover,
        'filas-alternadas': filas_alternadas,
      }"
    >
      <v-progress-linear
        slot="progress"
        color="accent"
        indeterminate
      ></v-progress-linear>
      <!-- Es necesario pasar los headers para que se muestre correctamente el texto de no-data
      ToDo mejorar documentación para uso de los headers-->
      <template v-if="tieneSlotHeader" v-slot:header="{ props: { headers } }">
        <thead class="v-data-table-header">
          <slot name="header" :headers="headers"></slot>
        </thead>
      </template>
      <!-- Slot para contraer/expandir filas de la tabla -->
      <template v-if="agrupar_filas" v-slot:[`group.header`]="{ items, isOpen, toggle }">
        <th :colspan="columna_seleccionar_todo ? headers.length+1 : headers.length" class="agrupar-titulo">
          <!-- Por el momento dejamos estos iconos por default pero se podrían customizar -->
          <v-icon @click="toggle"
          >{{ isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
          </v-icon>
          {{items[0][secciones_agrupar]}}
        </th>
      </template>
      <template slot="item" slot-scope="{ item, index }">
        <!-- En este slot se debe pasar se debe mostrar una fila de la tabla <tr> <td></td> <td></td>......</tr>
              Al slot se pasa la informacion props = { item }
        -->
        <slot
          name="item"
          :item="item"
          :index="index"
          :seleccionados="seleccionados"
        ></slot>
      </template>
      <template slot="footer">
        <slot name="footer"></slot>
      </template>
      <template slot="body.append">
        <slot name="body.append"></slot>
      </template>
      <template v-if="fila_totalizadora" slot="body.append">
        <tr :class="['fila-totalizadora', {'fondo-oscuro': total_oscuro}]">
          <td v-for="columna in total_columna-1" :key="columna"></td>
          <td>{{total_label}}</td>
          <td class="importe"><span :class="{'prefix': signo_pesos_light}">$</span>&nbsp;{{total_monto}}</td>
          <td v-for="columna in headers.length - total_columna - 1" :key="columna"></td>
        </tr>
      </template>
    </v-data-table>
    <v-row
      class="ca-tabla-footer text-center justify-end layout px-6 py-2"
      v-if="paginado"
      v-show="numeroDePaginas > 1"
    >
      <v-pagination
        :length.sync="numeroDePaginas"
        :total-visible="numeros_paginacion_visibles"
        class="paginado"
        v-model="opciones.page"
        @input="() => $emit('pagination:change', opciones.page)"
      ></v-pagination>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    id: {type: String, default: 'ca-tabla'},
    // Arreglo de items a mostrar
    items: {type: Array, default: () => []},
    // Arreglo de TableHeader, definido por vuetify en https://vuetifyjs.com/en/components/data-tables
    headers: {type: Array},
    // Especificar el numero de columnas
    headers_length: {type: Number},
    // Muestra la barra de carga
    loading: {type: Boolean, default: false},
    loading_text: {type: String, default: undefined},
    // Habilitar paginado (Si tiene más páginas que la cantidad de items entonces se muestra el paginado)
    paginado: {type: Boolean, default: false},
    // Items por pagina (Si tiene paginado)
    items_por_pagina: {type: Number, default: 10},
    // Máximo total visible de números de paginación
    numeros_paginacion_visibles: {type: Number, default: 5},
    // Texto para cuando no hay items
    no_data_text: {type: String},
    // Habilitar columna para seleccionar todas las filas
    columna_seleccionar_todo: {type: Boolean, default: false},
    // Items seleccionados (Se utiliza para SeleccionItemsCancelar en creacion de orden de pago
    // TODO ampliar esta funcionalidad para multiples paginas y mejorar lo que hay en la actualidad
    // para reducir acoplamiento
    seleccionados: {type: Array, default: () => []},

    // Estilización
    header_fijo: {type: Boolean, default: false},
    header_small: {type: Boolean, default: false},
    scrollable: {type: Boolean, default: false},
    filas_hover: {type: Boolean, defualt: false},
    filas_clickeables: {type: Boolean, default: false},
    filas_alternadas: {type: Boolean, default: true},
    altura_si_paginado: {type: Number, default: null}, //Setea una altura para la tabla si tiene más de una pag
    ocultar_header: {type: Boolean, default: false},
    dark: { type: Boolean, default: false },
    height: {type: Number, default: null}, // Height a setear para usar header_fijo

    /**
       * Virtual scrolling: Esta funcionalidad se encuentra funcionando de forma básica (Sin selects, filas de tamaño variable o
       *  distintos tamaños).
       *  TODO es necesario mejorar la UX para poder utilizar en prod ya que se producen saltos poco agradables a la vista
       *
       * Es necesitar la cantidad de items a mostrar en la "ventana" de virtual scrolling, y la altura de la fila de
       *  cada una las filas. Esto permite el correcto funcionamiento.
       */
    virtual_scrolling: {type: Boolean, default: false},
    items_virtual_scroll: { type: Number, default: 15}, // Cantidad de items a mostrar por vez
    altura_fila: { type: Number, default: 34}, // Es necesario pasar la altura de las filas

    /**
       * Paginado por API al cambiar de página
       *
       * No es posible utilizar paginado por API y virtual scrolling o filtrado local al mismo tiempo.
       */
    // Habilitar paginado por API. Emite evento @pagination:change ante cambio de página (Se debe especificar total_api)
    paginado_api: {type: Boolean, default: false},
    // Total de items (Se utiliza para paginado por API para calcular el total de páginas)
    total_api: {type: Number, default: 0},

    /**
       * Agrupación de filas: Funcionalidad que permite agregar una fila para contraer/expandir secciones de la tabla según se indique,
       * (actualmente se usa solo en presupuesto anual)
       *
       * - agrupar_filas: Se debe definir como true en caso de querer usar la agrupación de filas porque sino no se aplica la estilización por slots
       * - secciones_agrupar: Atributo que se tomara de todos los items para mostrar como titulo, ej: "tipo"
       * - invertir_agrupar: Atributo que permite invertir las secciones agrupadas
       * - custom_group: Función custom para la agrupación, si no se pasa ninguna los grupos serán ordenados por la tabla de manera alfabética
       */
    agrupar_filas: {type: Boolean, default: false},
    secciones_agrupar: { type: String, default: undefined },
    invertir_agrupar: { type: Boolean, default: false },
    custom_group: { type: Function},

    /**
       * Fila Totalizadora: fila sticky que muestra label "Total" y el mpnto que se pase por prop
       * - fila_totalizadora: Flag que indica si se debe mostrar la fila
       * - total_columna: Nro de columna donde se mostrará el label "Total"
       * - total_monto: Importe a mostrar
       * - total_oscuro: Flag que le pone un fondo color gris-claro a la fila
       * - total_label: Label que se mostrar indicando el total, por defecto es "Total"
       * - signo_pesos_light
       */
    fila_totalizadora: {type: Boolean, default: false},
    total_columna: { type: Number, default: 0 },
    total_monto: { type: String, default: '0,0' },
    total_oscuro: { type: Boolean, default: false },
    total_label: { type: String, default: 'Total' },
    signo_pesos_light: { type: Boolean, default: false },
  },
  data() {
    return {
      opciones: {
        page: 0,
        itemsPerPage: this.items_por_pagina,
      },
      seleccionados_copy: this.seleccionados,

      // Atributos utilizados en virtual scroll
      index_inicial_virtual_scroll: 0,
      // Items extra que se muestran arriba y abajo para mejorar el efecto visual del virtual scrolling (optimización)
      items_padding: this.items_virtual_scroll,
      timeout: null,
    };
  },
  mounted() {
    if (this.virtual_scrolling) {
      this.actualizarPaddings();
      let element = document.getElementById(this.id);
      element.style.setProperty('--maxHeight', this.height + 'px');
    }
  },
  watch: {
    seleccionados(newVal) {
      // Compara por largo de arreglos
      if (newVal.length !== this.seleccionados_copy.length) {
        this.setearItemsSeleccionados(newVal);
        this.seleccionados_copy = newVal;
      }
    },
    seleccionados_copy(newVal) {
      if (newVal.length !== this.seleccionados.length) {
        this.setearItemsSeleccionados(newVal);
        this.$emit('update:seleccionados', newVal); // Hay que actualizar los items seleccionados
      }
    },
  },
  computed: {

    /**
       * Id completo para la directiva v-scroll
       */
    idCompleto() {
      return '#' + this.id;
    },

    numeroDePaginas() {
      const total = this.paginado_api ? this.total_api : this.items.length;
      return Math.ceil(total / this.opciones.itemsPerPage);
    },
    heightTabla() {
      return this.numeroDePaginas > 1 ? this.altura_si_paginado : null;
    },
    tieneSlotHeader() {
      return !!this.$scopedSlots['header'];
    },

    /**
       * Cantidad de items visibles en el virtual scroll
       */
    cantidadItemsVisibles() {
      let count = this.items_virtual_scroll + 2 * this.items_padding;

      return Math.min(this.items.length - this.index_inicial_virtual_scroll, count);
    },

    /**
       * Si la tabla tiene virtual scrolling se precargan cierta cantidad de items, sino se muestran todos
       */
    itemsAMostrar() {
      return this.virtual_scrolling && !this.paginado
        ? this.items.slice(this.index_inicial_virtual_scroll, this.index_inicial_virtual_scroll + this.cantidadItemsVisibles)
        : this.items;
    }
  },
  methods: {
    // Setea selected a c/item seleccionado
    setearItemsSeleccionados(newVal) {
      this.items.forEach((item) => {
        item.selected = newVal.includes(item);
      });
    },

    /**
       * Al hacer scroll en la tabla se recalculan los items a mostrar y los estilos de la tabla
       */
    onScroll(e) {
      if (this.virtual_scrolling) {
        const {scrollTop} = e.target;

        // Índice de rows que se muestran
        let index_primer_fila_visible = Math.floor(scrollTop / this.altura_fila);

        // El primer item visible no puede ser posterior a la cantidad de items totales menos la cantidad de items del vs
        index_primer_fila_visible = Math.min(this.items.length - this.items_virtual_scroll, index_primer_fila_visible);
        let startRow = index_primer_fila_visible - this.items_padding;

        // Si el número de row es impar se va a la próxima (Ésto para mantener los colores de las rows)
        if (startRow % 2) {
          startRow++;
        }

        this.index_inicial_virtual_scroll = Math.max(0, startRow);

        this.actualizarPaddings();
      }
    },

    /**
       * Actualiza la estilización para el virtual scrolling
       */
    actualizarPaddings() {
      let element = document.getElementById(this.id);
      element.style.setProperty('--paddingTop', this.index_inicial_virtual_scroll * this.altura_fila + 'px');
      element.style.setProperty('--paddingBottom',
        (this.items.length - this.cantidadItemsVisibles - this.index_inicial_virtual_scroll) * this.altura_fila + 'px');
    },
    getHeight() {
      if (this.header_fijo) {
        return this.height;
      }
    }
  }
};
</script>

<style lang="scss">

  // Bloque previo a tabla que contiene generalmente un título para la tabla
  .ca-tabla-prev {
    width: 100%;
    padding: 0 10px;
    font-size: 15px;
    background-color: color(dark);
    color: color(celeste-agua);
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
  }

  .ca-tabla.v-data-table table {
    .columns {
      position: initial;
    }

    // Uso layout fixed. Se debe indicar width de columnas
    table-layout: fixed;

    border-collapse: collapse;

    thead.v-data-table-header {
      // Problemas con doble header al usar el slot
      &:nth-child(3) {
        display: none;
      }

      tr {
        height: $tabla-header-height;
        &:not(.v-data-table__progress) {
          th {
            background-color: color(dark);
          }
        }
        th {
          padding: 0 10px;
          color: color(blanco);
          font-size: $tabla-header-font-size;
          font-weight: 500;
          text-transform: uppercase;
          line-height: 1.2;
          white-space: normal;
          height: unset;
          &:focus {
            outline: none;
          }
          &.sortable {
            &.active {
              color: color(blanco);
              font-weight: bold;
            }
            &:hover {
              color: color(celeste-agua);
            }
            i.v-icon {
              color: color(primary) !important;
              font-size: 16px !important;
            }
          }
          &.destacado {
            color: color(celeste-agua);
          }
          &.fondo-oscuro {
            background-color: color(gris-oscuro);
          }
          .v-data-table__checkbox .v-icon {
            color: color(blanco) !important;
          }
        }
      }
    }
    tbody {
      tr {
        background-color: white;
        border-bottom: 1px solid #e9e9e9;
        &.v-data-table__empty-wrapper {
          color: color(texto-oscuro);
        }
        &:not(:last-child) {
         border-bottom: hidden !important;
          td:not(:last-child), td:last-child {
            border-bottom: hidden !important;
          }
        }
        &:hover:not(.v-data-table__expanded__row) {
          background-color: white;
        }
        td {
          padding: 0 0 0 10px;
          &:not(.checkbox-item) {
            padding: 0 10px;
          }
          font-size: 14px;
          height: $tabla-filas-height;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          .v-btn {
            margin: 0;
            height: $tabla-filas-height - 2px;
            &.v-btn--icon {
              width: $tabla-filas-height - 2px;
            }
          }
          .v-input--selection-controls {
            margin-top: 0;
          }
        }
      }
      th.agrupar-titulo {
        font-weight: 500;
        font-size: 14px;
        .v-icon:focus::after {
          opacity: 0;
        }
      }
    }
  }

  // Tabla scrollable: Debe setearse la altura máxima en los estilos del componente donde se utilice.
  .ca-tabla.ca-tabla--scrollable {
    overflow-y: auto;
  }

  .ca-tabla.ca-tabla--virtual-scroll {
    max-height: var(--maxHeight);
    overflow: auto;
    .v-data-table__wrapper {
      padding-top: var(--paddingTop);
      padding-bottom: var(--paddingBottom);
      overflow: visible;
    }
  }

  .ca-tabla.ca-tabla-header--small {
    thead.v-data-table-header tr {
      height: $tabla-header-height-small;
    }
  }

  // Tabla dark
  .ca-tabla.ca-tabla--dark.v-data-table {
    max-height: 172px;
    .v-data-table__wrapper {
      background-color: color(dark);
    }
    table tbody tr {
      background-color: color(dark);
      &:hover {
        background-color: color(gris) !important;
      }
    }
    &.filas-alternadas table tbody tr:nth-child(even) {
      background-color: color(dark-secund);
      &:hover:not(.v-data-table__expanded_row) {
        background-color: color(gris);
      }
    }
    td {
      color: color(blanco);
      height: 34px;
    }
  }

  // Fila totalizadora

  .fila-totalizadora {
    position: sticky;
    bottom: 0;
    font-weight: 700;
    &.fondo-oscuro {
      background-color: color(gris-claro) !important;
    }
    .importe {
      text-align: end;
      .prefix {
        color: color(gris-oscuro);
      }
    }
  }

  // Footer que contiene generalmente un paginador
  .ca-tabla-footer {
    height: unset !important;
    border-radius: 2px;
    background-color: color(gris-claro);
    align-items: center;
    font-size: 18px;

    .paginado {
      margin-top: 3px !important;
      width: unset;
      li {
        min-width: 30px;
      }
      li:first-child,
      li:last-child {
        max-width: 30px;
      }
      button {
        padding: 0;
        min-width: 25px !important;
        min-height: 25px;
        height: 25px;
        margin: 0 5px;
      }
      .v-icon {
        font-size: 18px;
      }
      .v-pagination__more {
        margin: unset;
      }
    }
  }
</style>